export const en = {
  About: 'About',
  // WhatWeDo: 'What We Do',
  LiveVideo: 'Live Video',
  // Solutions: 'Solutions',
  // Construction: 'Construction',
  // Retail: 'Retail',
  // HealthCare: 'Health Care',
  // EventVenues: 'Event Venues',
  // Transportation: 'Transportation',
  // Hospitality: 'Hospitality',
  // Platforms: 'Platforms',
  Client: 'Client',
  // HowItWorks: 'How it works',
  Team: 'Team',
  Media: 'Media',
  Awards: 'Awards',
  News: 'News',
  Apple: 'Apple',
  Contacts: 'Contacts',
  // SmartVenues: 'Smart Venues',
  // SmartConstruction: 'Smart Construction',

  // home
  'home-head-black-1': 'A Platform To Enable ',
  'home-head-red-1': 'AI',
  'home-head-black-2': '&',
  'home-head-red-2': 'BigData',
  'home-head-small': 'Compathnion Technology provides market-leading AI Infrastructure which enables data immediacy aiding swift decision making by decision makers.',
  'home-contact-btn': 'Contact Us',
  'section-title-1': 'Indoor Positioning Applications',
  'section-sub-title-1': 'Indoor venue positioning, human sensing and security protection',
  'section-1-img-1-title': 'Smart Manufacturing',
  'section-1-img-1-p': 'We distribute artificial intelligence solutions to integrate the value chain for product design, production, and services.',
  'section-1-img-2-title': 'Smart Retail',
  'section-1-img-2-p': 'Electronic tracking with wayfinding solutions is the first step to enhance the customer experience inside your brick and mortar stores.',
  'section-1-img-3-title': 'Construction',
  'section-1-img-3-p': 'Centralized visual interface, including workers position, machine operating status, CCTV display and customized alert pages.',
  'section-title-2': 'What We Provide',
  'section-2-row-1-title': 'UWB Positioning',
  'section-2-row-1-detail': 'Ultra-wideband Indoor Positioning Technique: <br/>High precision positioning service within 10cm~30cm for a split second. Unlimited number of devices supported. Consistent. Applicable in long-run. ',
  'section-2-row-2-title': 'Device Positioning',
  'section-2-row-2-detail': 'Two schemes provided: <br/>Smartphone positioning with custom app for large area; Bluetooth device positioning for manufacturer and hospital. ',
  'section-2-row-3-title': 'Customized Service',
  'section-2-row-3-detail': 'Feature design and data analytics for your needs. Alert system, ads recommendation, distance measurement, all based on collected locational information. ',

  // solutions
  'solutions-head-h1': 'Comprehensive <br/> multimedia solution',
  'solutions-head-small': 'From large TV walls to KIOSK multi-touch screens and the latest wave of somatosensory devices, according to different commercial marketing stages, we have developed corresponding application technologies to help customers create new-style business operation models and enhance brand market visibility, and Increase corporate profits and brand value.',
  'solutions-content-title': 'Through comprehensive multimedia interaction Solutions become a communication platform between brands and consumers',
  'solutions-item-1-title': 'Construction',
  'solutions-item-1-detail': 'Interactive maps and wayfinding for smart office',
  'solutions-item-2-title': 'RETAIL',
  'solutions-item-2-detail': 'Maps and wayfinding for shopping centers and retailers',
  'solutions-item-3-title': 'HEALTHCARE',
  'solutions-item-3-detail': 'Interactive maps and wayfinding for hospitals',
  'solutions-item-4-title': 'EVENT VENUES',
  'solutions-item-4-detail': 'Event maps and wayfinding for trade shows, conventions and festivals.',
  'solutions-item-5-title': 'TRANSPORTATION',
  'solutions-item-5-detail': 'Indoor maps and wayfinding for airports and train stations',
  'solutions-item-6-title': 'HOSPITALITY',
  'solutions-item-6-detail': 'Maps and wayfinding solution for hotels, cruise lines and theme parks.',

  // platforms
  'platforms-head-h1': 'Deploy new digital <br />services inside your <br />smart buildings',
  'platforms-head-small': 'A simple hit on the “Publish” button will allow you to share your map with everyone!',
  'platforms-item-1-title': 'Wayfinding',
  'platforms-item-1-detail': 'Mapwize has a Search Engine that allows users to locate any kind of resources on the map whether it is a meeting room or a printer.' +
    '<br /><br />' +
    'Mapwize provides a powerful Direction Engine to compute the best route towards your destination and can also optimize multi-destination itineraries. Reduced mobility users can select a dedicated mode to obtain suitable itineraries.',
  'platforms-item-2-title': 'CMS',
  'platforms-item-2-detail': `Mapwize uses outdoor global maps and adds indoor data to them. This way, our maps combine both indoor and outdoor services using the same tool.
    <br/><br/>
    All data not being of interest for everyone, Mapwize offers different Universes to display appropriate content in accordance with user roles (visitors, occupants, maintenance workers, security agents, etc.). Mapwize can manage an unlimited number of Universes per venue.
    <br/><br/>
    Mapwize has always been a multilingual platform with the ability to handle any language including Non-Europeans (Russian, Chinese, Arabic, etc.).`,
  'platforms-item-3-title': 'Dashboard',
  'platforms-item-3-detail': `Mapwize’s back-office, the Studio, is able to process the most common building file formats such as Autocad or GeoJSon. This way the overall floorplan import process is rapidly executed even by non-specialists.
    <br/><br/>
    Once existing floorplans are imported, the Studio provides all the necessary tools to add data and customize the maps. This includes but is not limited to: Universes, Points-of-Interest, Directions, Languages. Changes and updates are propagated in real-time on the platform.`,
  'platforms-item-4-title': 'Framework',
  'platforms-item-4-detail': `Mapwize works with any Indoor Positioning System (IPS) including but not limited to: Beacons, Wi-Fi, Li-Fi, Ultrasounds, Earth’s Magnetic field, Sensor fusion. Additionally, Mapwize provides a unique framework designed to combine multiple IPSs and select the most accurate system at anytime. Also, this framework enables advanced filters to increase position accuracy based on building topology.
    <br/><br/>
    This framework, called Indoor Positioning is available as an Open Source project under the MIT License.`,
  'platforms-item-5-title': 'Automation',
  'platforms-item-5-detail': `Mapwize is an open platform by design because we believe Indoor Mapping should be a core component to many third-party software applications. Accordingly, we also believe it is of the most importance to give developers a highly customizable mapping component.
    <br/><br/>
    Therefore, Mapwize comes with a fully interoperable Application Programming Interface (API) to permit server-side automation and multiple SDKs for iOS, Android and Javascript. This way, developers can easily embed Mapwize maps inside their own applications.
    <br/><br/>
    Mapwize API and SDKs are freely available on Github.`,
  'platforms-item-6-title': 'Security',
  'platforms-item-6-detail': `Security is a top concern here at Mapwize. Our maps are protected by strong access keys which are both customizable in scope (universes, floors, etc.) and duration.
    <br/><br/>
    Mapwize is hosted on the Microsoft Azure Cloud and is either available in SaaS mode (Multi-tenant server or private server) or on-premises.`,

  // how it works
  'howitworks-head-h1': 'How our service works',
  'howitworks-head-small': 'A seamless path for buildings Indoor mapping just became easy. super easy to integrate and our customers would tell you the same! We are a developer-friendly company committed to providing the most complete tools for those who create the best mobile and web applications.',
  'howitworks-item-1-title': '整合服務',
  'howitworks-item-1-detail': '協助增建客戶需求功能。',
  'howitworks-item-2-title': '客製化可視化介面',
  'howitworks-item-2-detail': '客製化可視化介面，包含生產數據、機台運轉狀況、庫存資料呈現、客製化需求頁面。便利使用端快速了解生產資訊內容。',
  'howitworks-item-3-title': '數據收集',
  'howitworks-item-3-detail': '提供機台生產數據資料擷取功能。透過PLC資料擷取盒，獲取機台內部生產數據。解決無法取得機台生產資訊問題。',
  'howitworks-item-4-title': '依據機台數據進行分析',
  'howitworks-item-4-detail': '依據機台數據進行分析，透過AI自主學習技術進行問題建模，進而改善生產問題，提升生產效能。解決生產中問題狀況，有效提升生產效能與減少庫料耗損。',

  // imdf
  'imdf-head-h1': 'Apple Indoor <br/> Positioning Technology',
  'imdf-head-small': `Compathnion provides zero-additional hardware solution using Any WiFi based on Wherami technology. In iOS, we have cooperation with Apple ecosystem.
    <br/>
    Apple introduced indoor positioning technology for iOS on Any WiFi, which is accurate to about 3-5 metres. They have developed a new data model for positioning in iOS apps called IMDF.
    <br/>
    Compathnion is the 1st Large Scale Zero-Additional Hardware LBS Solution for both Android and iOS in the Greater Bay Area. And we have deployed the iOS solution in many venues.`,
  'imdf-item-1-title': 'How to enable iOS positioning?',
  'imdf-item-1-detail': `Compathnion has fruitful experience in implementation of the application with the iOS solutions. The steps needed to provide Apple Indoor Navigation is as follows:
    <br/><br/>
    <p>1. Register company account and venues in Apple Map Connect (https://register.apple.com/indoor)</p>
    <p>2. Create an IMDF and submit to Apple Map Connect</p>
    <p>3. Once approved, execute the site survey</p>
    <p>4. Submit the site survey data</p>
    <br/><br/>
    We provide a one-stop consultation and implementation service for IMDF creation, site survey, APP development, and maintenance.`,
  'section-2-title': 'Benefits of activating iOS Indoor Positioning',
  'imdf-horizontal-item-1-title': 'Native iOS support',
  'imdf-horizontal-item-1-content': `Seamless transition between indoor and outdoor positioning.<br/>
    Optimized battery consumption: the iOS Core Location service is optimized with iOS devices and minimizes the battery consumption during the positioning and navigation.`,
  'imdf-horizontal-item-2-title': 'A network effect',
  'imdf-horizontal-item-2-content': `As venue owner, once the iOS indoor positioning is activated in your venue, it can benefit for all apps developers working with the iOS platform.<br/>
    On the app side, the coverage indoor positioning will keep expanding once any venues enable indoor positioning on iOS.`,
  'imdf-horizontal-item-3-title': 'City-wide <br/> positioning service',
  'imdf-horizontal-item-3-content': 'iOS indoor positioning is designed to support city-wide apps. The service does not limit to a single venue, the indoor positioning service is optimized in a city-based level and even across cities.',

  // Contact
  'contact-section-1-title': 'Contact Us',
  'contact-title': 'Compathnion Technology Limited',
  'contact-content-address': `
    Unit 617, 6/F, 12W Science Park West Avenue,
    <br />
    Hong Kong Science Park,
    <br />
    Shatin, N.T., Hong Kong`,
  'contact-content-info': `
    Email:  <br />
    <a href="mailto: info@compathnion.com">info@compathnion.com</a> <br />
    Telephone: <br />
    <a href="tel:+852-3465-5803">(852) 3465 5803</a><br/>
    Website: <br/>
    <a href="https://compathnion.com">https://compathnion.com</a>`,

  // Construction
  'construction-title': 'Construction',
  'construction-detail': 'Customized visual interface, including production data, machine operating status, inventory data display and customized demand pages. Users can easily and quickly understand the content of production information.',
  'construction-item-1-title': '工業數位整合服務',
  'construction-item-1-detail': `
    工業4.0著重在將現有的工業相關的技術、銷售與產品體驗統合起來，是建立具有適應性、資源效率和人因工程學的智慧型工廠，我們將提供工廠數位化所需要的整合性技術服務。
    <br/><br/>
    MES：工廠生產履歷資訊建置協助服務
    <br/><br/>
    SCADA：環境監測與生產資訊可視化介面呈現應用服務
    <br/><br/>
    PLC：生產機台數據收集與自動化控制系統
    <br/><br/>
    AI深度學習技術：大數據深度分析與改善生產曲線服務系統。
  `,
  'construction-item-2-title': '整合服務架構',
  'construction-item-2-detail': `
    MES顧問管理，可視化建置服務，機台生產數據收集，AI深度學習技術
    <br/><br/>
    透過MES 系統架構，整合生產時所產生的數據資料，圖表化呈現顯示
    <br/><br/>
    透過我們的PLC資料擷取盒，主動獲取機台生產參數與數據資料，穩定傳送到MES資料庫中進行記錄。
    透過MES系統判斷彙整後，提供給予SCADA可視化介面進行數據資料呈現。
    <br/><br/>
    機台存取的數據資料，進入我們的AI深度學習技術，依據大數據分析後進而調整生產控制，有效提升生產效能。
  `,

  // Our Client
  'our-client-section-1-title': 'Best Cross-Platform LBS Solution Supports',

  // our team
  'our-team-title': 'Our Team',
  'our-teammate-1-name': 'Professor Gary CHAN',
  'our-teammate-1-position': 'Founder',
  'our-teammate-1-description': `
  Dr. S.-H. Gary Chan is currently a Professor in the Department of Computer Science and Engineering, The Hong Kong University of Science and Technology (HKUST).  He is also an Affiliate Professor in Innovation, Policy and Entrepreneurship Thrust of HKUST(GZ), Chair of the Committee on Entrepreneurship Education Program at HKUST, and Board Director of Hong Kong Logistics and Supply Chain MultiTech R&D Center (LSCM).  He received his MSE and PhD degrees in Electrical Engineering with a Minor in Business Administration from Stanford University (Stanford, CA).  He obtained his BSE degree (highest honor) in Electrical Engineering from Princeton University (Princeton, NJ), with certificates in Applied and Computational Mathematics, Engineering Physics, and Engineering and Management Systems.
  <br /><br />
  Professor Chan has co-founded and transferred his research results to several startups. Due to their innovations and commercial impacts, his startups and research projects have received local and international accolades. Notably, he received Hong Kong Chief Executive's Commendation for Community Service for ''outstanding contribution to the fight against COVID-19" in 2020.  He is the recipient of Google Mobile 2014 Award and Silver Award of Boeing Research and Technology. He is a Chartered Fellow of The Chartered Institute of Logistics and Transport (FCILT).
  `,
  'our-teammate-2-name': 'Mr Arthur CHAN',
  'our-teammate-2-position': 'Director & CEO',
  'our-teammate-2-description': `
  Since his university days, Arthur always believes that Data Technology will affect everyone in the future, possibly more than the Internet has been.
  <br /><br />
  Always a high achiever as he graduated with First Class Honors in Computer Science Engineering from the HKUST, and was an exchange scholar at UCLA.
  <br /><br />
  Arthur is a recognized expert on the Internet of Things, Edge Computing and Open Source Software Development. He was invited to speak at professional events. Arthur currently serves as a Board Member on the Internet of Things.
  `,

  // news
  'news-section-title-1': 'News',

  // Awards
  'awards-section-title-1': 'Our Accomplishments',

  // live video
  'live-video-head-h1': 'Video Demonstration',
  'live-video-head-small': 'Top technology for the construction.',
  'live-video-section-title-1': 'Construction Site AI',

  // footer
  'footer-title': 'Contact',
  'contact-email': 'Email: info@sagadigits.com',
  'contact-tel': 'Tel: (852) 3465 5803',
  'contact-address': 'Address: Unit 617, 6/F, 12W Science Park West Avenue, Hong Kong Science Park Phase III, Shatin, N.T., Hong Kong',
  'footer-copyright': 'Compathnion, A Member of SagaDigits Group © 2023.'
}
